import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminNavigation from './AdminNavigation';
import { useNavigate } from 'react-router-dom';

function UpdateFooterSetting() {
    const [footer_section, setFooterText] = useState('');
    const navigate = useNavigate();
    const [id, setID] = useState(null);
    const TOKEN = localStorage.getItem('adminToken');

    useEffect(() => {
        setID(localStorage.getItem('ID'));
        setFooterText(localStorage.getItem('Footer Text'));
    }, []);

    const updateSelectedFooterSettingData = async (e) => {
        e.preventDefault(); // Prevent form submission default behavior
        try {
            const res = await axios.put(
                `${process.env.REACT_APP_API_URL}/setting/${id}`,
                { footer_section },
                {
                    headers: {
                        Authorization: `Bearer ${TOKEN}`,
                    },
                }
            );
            if (res.status === 200) {
                // Navigate to Settings with a state flag to trigger re-fetch
                navigate('/admin/settings', { state: { refresh: Date.now() } });
            } else {
                console.error('Failed to update');
            }
        } catch (error) {
            console.error('Error updating footer:', error);
        }
    };

    return (
        <>
            <div id="wrapper" className="toggled">
                <AdminNavigation />
                <div id="page-content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 mx-auto"></div>
                            <h2>Update Footer Text</h2>
                            <form>
                                <label>Footer Section:</label>
                                <textarea
                                    name="footer_section"
                                    id="footer_section"
                                    className="form-control"
                                    placeholder="Enter Footer Text"
                                    value={footer_section}
                                    onChange={(e) => setFooterText(e.target.value)}
                                    required
                                ></textarea>
                                <br />
                                <input
                                    type="submit"
                                    onClick={updateSelectedFooterSettingData}
                                    className="btn btn-primary mb-2"
                                    id="update_footer"
                                    value="Update Footer"
                                />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UpdateFooterSetting;